/**
 * This file is a component for E2 UI Customization (This is subject to change based off of mediaType)
 */

import React, {useState, useEffect} from 'react';
import { Grid, Tooltip, FormControlLabel, Checkbox} from '@material-ui/core';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';

export default function ShowC3(props)
{
    const [showC3, setShowC3] = useState(false);

    /** Set activity panel to value being passed through props */
    useEffect(() => {
        setShowC3(props.value);
    },[props.value]);
    
    /**Handle changes to activity panel checkbox */
    const handleShowC3 = () => {
        setShowC3(!showC3);
        props.onChange(!showC3)
    }

    return(
        <div>
            <Grid container direction="row" alignItems="center">
                <Grid item>
                    <FormControlLabel
                    control={
                        <Checkbox
                        checked={showC3}
                        onChange={handleShowC3}
                        name="Show C3"
                        color="primary"
                        />
                    }
                    label="Show C3"
                    />
                </Grid>
                <Grid item>
                    <Tooltip title="Show the C3 widget">
                        <LocalAtmIcon color="primary"/>
                    </Tooltip>
                </Grid>
            </Grid>
        </div>
    );
}

